import Vue from "vue";
import VueApollo from "vue-apollo";
import apolloClient from "./vue-apollo";
import VueRouter from "vue-router";
import VueI18n from "vue-i18n";

import App from "./App.vue";
import translations from "./translations";

Vue.config.productionTip = false;
Vue.use(VueApollo);
Vue.use(VueRouter);
Vue.use(VueI18n);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      components: require("./containers/Home.vue"),
    },
    {
      path: "/timeline",
      components: require("./containers/TimelinePage.vue"),
    },
    {
      path: "/map",
      components: require("./containers/MapPage.vue"),
    },
    {
      path: "/report",
      components: require("./containers/ReportPage.vue"),
    },
    {
      path: "/resources",
      components: require("./containers/ResourcesPage.vue"),
    },
    {
      path: "/about",
      components: require("./containers/AboutPage.vue"),
    },
    {
      path: "/podcast",
      components: require("./containers/PodcastPage.vue"),
    },
    {
      path: "/myths",
      components: require("./containers/MythsPage.vue"),
    },
    // {
    //   path: "/partners",
    //   components: require("./containers/PartnersPage.vue"),
    // },
    // {
    //   path: "/article/:id",
    //   components: require("./containers/Article.vue"),
    // },
    // {
    //   path: "/category/:id",
    //   components: require("./containers/Category.vue"),
    // },
  ],
});

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "en", // set locale
  messages: translations, // set locale messages
});

new Vue({
  apolloProvider,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
